import { loadStripe } from '@stripe/stripe-js';

export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51T2K4uR640qUzVcQTUdhZY2OLQIhpBuVsG8TMElF0nNfNY8HNoStadhhnRKG6qtqIVEDG4o6KxhvtRSBdQXeQuSP00vtO6RbMU';
export const STRIPE_BROWSER_FALLBACK_URL = 'https://maestrodesktop.com/subscribe';

/**
 * Load Stripe.js with explicit error surfacing. Returns null on failure.
 * Pass forceReload=true after Retry to bust a poisoned promise cache.
 */
export async function loadStripeSafe(forceReload = false) {
  if (forceReload) {
    cachedPromise = null;
  }
  if (!cachedPromise) {
    cachedPromise = loadStripe(STRIPE_PUBLISHABLE_KEY).catch((err) => {
      cachedPromise = null;
      const message = err?.message || 'Failed to load Stripe.js';
      console.error('[Stripe] load failed:', message, err);
      throw new Error(message);
    });
  }
  try {
    return await cachedPromise;
  } catch (err) {
    return null;
  }
}

let cachedPromise = null;

export function resetStripeLoaderCache() {
  cachedPromise = null;
}
